const AboutUs = () => {
    return <h1>Blog Articles</h1>;
};

export default AboutUs;